import { TbCode } from "react-icons/tb";

import { PERMISSIONS } from "@/constants/permissions";
import type { NavigationRoute } from "@/types/navigation-route";
import { APP_ROUTES_TO } from "@/utils/routes";

export const developerRoutes: NavigationRoute[] = [
    {
        meta: {
            label: "developer",
            order: 7,
            icon: TbCode,
            visibleInSidebar: false,
            permissions: [PERMISSIONS.CALL_SVC_ADMIN_BASE],
        },
        to: APP_ROUTES_TO.DEVELOPER,
    },
];
